import dashboard from "./menu/dashboard";
import chat from "./menu/chat";
import report from "./menu/report";
import setting from "./menu/setting";
import user from "./menu/user";
import subscription from "./menu/subscription";

export default [
  ...dashboard,
  ...chat,
  ...report,
  ...setting,
  ...user,
  // ...subscription,
]
